/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, TextField, Checkbox, FormControlLabel } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  setSearchInput,
  getReportData,
  setRiderReportData,
} from '../Store/actions';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';

import { validateDate } from '../../../../SharedModules/utilities/dateUtilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import {
  CHECK_NUMBER_REQUIRED,
  NO_DATA,
  REBATE_SELECT,
  RIDER_NUMBER_VALID,
} from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const RequestRider = (props) => {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    selectedPlanType,
    rebateProgram: rebateProgramValue,
    rebateProgramList: rebateProgramListData,
    fromDateValue,
    isAllRebateProgram: isAllRebateProgramValue,
    riderNumber: riderNumberValue,
    searchResult,
  } = useSelector((state) => state?.sharedState?.RiderReducer);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [radioList, setRadioList] = React.useState([]);
  const [selectList, setSelectList] = React.useState([]);
  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [fromDate, setFromDate] = React.useState(fromDateValue);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [errorList, setErrorList] = React.useState(errors);
  const [isAllRebateProgram, setIsAllRebateProgram] = React.useState(
    isAllRebateProgramValue
  );
  const [riderNumber, setRiderNumber] = React.useState(riderNumberValue);
  const [searchClicked, setSearchClicked] = React.useState(false);

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );

    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
    }
  }, [planType]);

  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);
  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
          disabled: isAllRebateProgram,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList, isAllRebateProgram]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  // Highlights the tab if any error
  React.useEffect(() => {
    if (errorList.length > 0) {
      tabHighLigther('/rider', true);
    } else {
      tabHighLigther('/rider', false);
    }
  }, [JSON.stringify(errorList)]);
            
  // remove no data error msg
  React.useEffect(() => {
    dispatch(setSearchInput({errors: []}) );
  }, [ planType, planTypeList, rebateProgram, fromDate, isAllRebateProgram, riderNumber]);
    
  // function to validate from Date on onblur
  const handleOnBlur = (type, input) => {
    const value = autoFormateDate(input);
    let allErrors = errorList || [];
    let fromError = [];
    /* istanbul ignore else */
    if (type === 'fromDate') {
      setFromDate(value.toUpperCase());
      fromError = validateDate(value, 'fromDate');
      allErrors = [...allErrors, ...fromError];
    }

    setErrorList(allErrors);
  };

  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen

  const handleSearchClick = () => {
    let allErrors = [];
    if (!isAllRebateProgram && rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }

    const fromError = validateDate(fromDate, 'fromDate');

    allErrors = [...allErrors, ...fromError];

    const regex = /^[1-9][0-9]*$/;

    if (riderNumber.trim().length > 0) {
      /* istanbul ignore else */
      if (!regex.test(riderNumber)) {
        allErrors.push({
          field: 'riderNumber',
          message: RIDER_NUMBER_VALID,
        });
      }
    }

    setErrorList(allErrors);
    let rebateProgrameName =
      selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
      rebateProgrameName?.shortDescr || ''
    }`;
    dispatch(
      setSearchInput({
        fromDateValue: fromDate,
        errors: allErrors,
        selectedPlanType: planType,
        rebateProgram,
        isAllRebateProgram,
        rebateProgrameName,
        riderNumber,
        displayObj: {
          rebateProgram,
          fromDateValue: fromDate,
          isAllRebateProgram,
          riderNumber,
          rebateProgrameName,
        },
      })
    );

    if (allErrors.length === 0) {
      setSearchClicked(true);
      dispatch(setRiderReportData({}));
      dispatch(
        getReportData({
          allRebateProgramCheckbox: isAllRebateProgram ? 1 : 0,
          asOfDate: fromDate,
          rebateProgramCode: isAllRebateProgram ? null : rebateProgram,
          riderNumber: riderNumber,
        })
      );
    }
  };
  if (
    searchClicked &&
    (searchResult?.reportByYear?.length > 0 ||
      searchResult?.reportByAllRpc?.length > 0 ||
      searchResult?.reportByIndividualRpc?.length > 0)
  ) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));

    updateTabs.push({
      navTo: '/riderdetails',

      value: 'Rider Details',
    });

    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));

    props &&
      props.history &&
      props.history.push({
        pathname: '/riderdetails',
      });
    dispatch(clearReduxForFilterAndSort('/riderdetails'));
  }

  let errorMessages = [...new Set(errorList.map((obj) => obj.message))];
  errorMessages = errorMessages.map((message) => {
    return message.replace('date range', 'As Of Date');
  });
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      <CustomSeparator parent1="State Reports" parent2="Rider" />

      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />

      <div className="tab-body" />
      <div className="row">
        <div className="col-4 frr-two-col-radio">
          <RadioGroupComponent
            data-testid="Rider-report-plan-type"
            id="filter-plan-by-radio-btn-action"
            labelName="Plan Type"
            required
            optionList={radioList || []}
            defaultValue={planType}
            filterAction={(value) => {
              setPlanType(value);
              setRebateProgram('-1');
              const errors = errorList.filter(
                (error) => error.field !== 'rebateProgram'
              );
              setErrorList([...errors]);
            }}
            className="log-batch-filter-radio frr-checkInvoiceRadio"
          />
        </div>
        <div className="col-4">
          <>
            <Fieldset label="Rebate Program" required>
              <div style={{ marginTop: 18 }}>
                <SelectBoxComponent
                  data-testid="Rider-report-rebate-program"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Rebate Program"
                  required
                  select
                  selectOne
                  disabled={isAllRebateProgram}
                  optionList={selectList || []}
                  defaultValue={rebateProgram}
                  filterAction={(value) => {
                    setRebateProgram(value);
                    const errors = errorList.filter(
                      (error) => error.field !== 'rebateProgram'
                    );
                    setErrorList([...errors]);
                  }}
                  isError={
                    errorList.find((error) => error.field === 'rebateProgram')
                      ?.message
                  }
                />
              </div>
            </Fieldset>
          </>
        </div>
        <div className="col-4">
          <Fieldset label="As of Date" required>
            <div className="form-wrapper p-0 mt-n3">
              <div className="mui-custom-form input-md field-xl">
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="As of Date"
                      id="As of Date"
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10, 'aria-describedby': '' }}
                      required
                      name="From"
                      value={fromDate}
                      error={
                        errorList.filter((error) => error.field === 'fromDate')
                          ?.length > 0
                          ? 'mandate-fields'
                          : ''
                      }
                      data-testid="rider-from-date"
                      helperText={
                        errorList.find((error) => error.field === 'fromDate')
                          ?.message
                      }
                      className="mandate-fields frr-display-hidden-label"
                      onBlur={(e) => handleOnBlur('fromDate', e.target.value)}
                      onChange={(e) => {
                        setFromDate(e.target.value.toUpperCase());
                        setErrorList([
                          ...errorList.filter(
                            (error) => error.field !== 'fromDate'
                          ),
                        ]);
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
          </Fieldset>
        </div>
      </div>
      <div className="row">
        <div className="col-4">
          <div style={{ marginTop: 52 }}>
            {/* <span style={{ marginLeft: 5, marginRight: 5 }}>
              All Rebate Program:
            </span> */}
            <FormControlLabel
              control={
                <>
                  <div style={{ width: 145, marginLeft: 8 }}>
                    All Rebate Program:
                  </div>
                  <Checkbox
                    color="primary"
                    id="All_Rebate_Program_chk"
                    className="frr-display-hidden-label"
                    inputProps={{ id: 'All_Rebate_Program_chk' }}
                    data-testid="Rider-report-all-rebate-checkbox"
                    onChange={(e) => {
                      setIsAllRebateProgram(!isAllRebateProgram);
                    }}
                    checked={isAllRebateProgram}
                  />
                </>
              }
              // label="All Rebate Program"
              className="frr-display-hidden-label"
            />
          </div>
        </div>
        <div className="col-4">
          <Fieldset label="Rider Number" required={false}>
            <div className="form-wrapper p-0 mt-n3">
              <div className="mui-custom-form input-md field-xl">
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={12}>
                    <TextField
                      label="Rider Number"
                      id="Rider Number"
                      data-testid="Rider-report-number"
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required={false}
                      value={riderNumber}
                      className="mandate-fields frr-display-hidden-label"
                      onChange={(e) => {
                        const regex = /^[1-9][0-9]*$/;
                        const value = e.target.value.trim();
                        /* istanbul ignore else */
                        if (regex.test(value) || value === '') {
                          setRiderNumber(e.target.value);
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
          </Fieldset>
        </div>
      </div>
      <div className="row" style={{ marginTop: 30 }}>
        <div className="btn-wrapper col-12">
          <Button
            data-testid="Rider-report-search-btn"
            onClick={handleSearchClick}
            className="btn btn-success btn-search float-right"
          >
            <SVGComponent iconName="Icon-search" /> Search
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RequestRider;
